<template>
  <div class="w-full h-full flex align-center justify-center lg:col-6 md:col-12">

    <SmartModal type="default" icon="union" title="">
      Esse sistema legado deve ser acessado através do novo TIM Smart (<strong>www.timsmart.com.br</strong>).<br/>
      Aguarde! você será redirecionado automaticamente.
    </SmartModal>
  </div>
</template>
<script>
// @flow
import { mapActions } from 'vuex';

export default {
  created() {
    setTimeout(() => { window.location = '/';/*process.env.VUE_APP_TIM_SMART */ }, 1000);
  },
  name: 'Redirecionar',
  data: () => ({
    registration: '',
    password: '',
    isLoading: false,
    modal: null
  }),
  methods: {
    ...mapActions({
      login: 'auth/login',
      verifyAccess: 'auth/verifyAccess'
    })
  },
  computed: {
  }
};
</script>
